<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md10 sm12 class="pa-1">
          <h3 class="text-center">Patients</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-inner-icon="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text title="Add new" href="/clients/create" @click.stop.prevent="goTo('/clients/create')">
                <v-icon left>mdi-clipboard-plus-outline</v-icon>Add
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="clients" :search="filterBy" dense>
                <template v-slot:[`item.name`]="{ item }">
                  <td>
                    <inertia-link :href="'/clients/' + item.id">{{ item.name }}</inertia-link>
                  </td>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                  <delete-client v-if="canDelete" :client="item"></delete-client>
                </template>
              </v-data-table>
              <!-- <iframe src="http://kmpdc.go.ke/Registers/General_Practitioners.php" width="1300px" frameborder="0"></iframe> -->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import AppLayout from '@/Layouts/MainLayout.vue'
  const DeleteClient = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "clients" */ '@/Components/Clients/components/deleteClient')

  export default {
    name: 'ClientsIndex',
    components: {
      DeleteClient,
    },
    metaInfo () {
      return {
        title: 'Clients',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    layout: AppLayout,
    props: [
      'clients', 'canDelete'
    ],
    data () {
      return {
        filterBy: '',
        headers: [
          {
            text: 'Name', value: 'name'
          },
          {
            text: 'Gender', value: 'gender'
          },
          {
            text: 'Age', value: 'age-group'
          },
          {
            text: 'Phone', value: 'phone'
          },
          {
            text: 'Email', value: 'email'
          },
          {
            text: '', value: 'delete', align: 'right'
          }
        ]
      }
    },
    methods: {
      somemethod () {
        axios.get('http://kmpdc.go.ke/Registers/General_Practitioners.php')
      }
    },
  }
</script>
